import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { borderRadius, layoutGap } from '../../../theme/theme';
import WorkspaceIntroCard, { type WorkspaceIntroCardProps } from './WorkspaceIntroCard';

interface WorkspaceGuideDialogProps extends WorkspaceIntroCardProps {
  open: boolean;
  onClose: () => void;
  dialogTitle: string;
}

const WorkspaceGuideDialog: React.FC<WorkspaceGuideDialogProps> = ({
  open,
  onClose,
  dialogTitle,
  ...cardProps
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      aria-label={dialogTitle}
      aria-labelledby="workspace-guide-dialog-title"
      sx={{ zIndex: (theme) => theme.zIndex.tooltip + 1 }}
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          maxHeight: (theme) => `calc(100% - ${theme.spacing(4)})`,
          borderRadius: `${borderRadius.lg}px`,
          backgroundImage: 'none',
          overflow: 'hidden',
        },
      }}
    >
      <DialogContent
        sx={(theme) => ({
          flex: '1 1 auto',
          minHeight: 0,
          overflowY: 'auto',
          p: { xs: 1, md: 1.35 },
          pb: layoutGap.section,
          [theme.breakpoints.up('md')]: { pb: layoutGap.dense },
        })}
      >
        <Typography
          id="workspace-guide-dialog-title"
          sx={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            p: 0,
            m: -1,
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            whiteSpace: 'nowrap',
            border: 0,
          }}
        >
          {dialogTitle}
        </Typography>
        <WorkspaceIntroCard {...cardProps} />
      </DialogContent>
      <DialogActions
        sx={{ flexShrink: 0, px: { xs: 1.25, md: 1.6 }, pb: 1.25, pt: 0 }}
      >
        <Button variant="contained" onClick={onClose}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkspaceGuideDialog;
